import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AgGridListComponent } from '../../components/ag-grid-list/ag-grid-list.component';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ProctoringService } from '../../services/proctoring.service';
import environment from '../../../environments/environment';

@Component({
  selector: 'app-face-logs-list-page',
  imports: [CommonModule, FormsModule, HeaderComponent, AgGridListComponent],
  templateUrl: './face-logs-list-page.component.html',
  styleUrl: './face-logs-list-page.component.css'
})
export class FaceLogsListPageComponent {

  page_name = 'Face Mismatch Logs';
  params: any = {};
  items: any = [];

  columns: any = [
    {
      headerName: 'User', flex: 1.5, minWidth: 140,
      cellRenderer: (p: any) => {
        const name = p.data?.user_name || '-';
        const email = p.data?.user_email || '';
        return `<div style="display:flex;flex-direction:column;justify-content:center;height:100%;line-height:1.4">
          <span style="font-weight:600;font-size:13px">${name}</span>
          ${email ? `<span style="font-size:12px;color:#6b7280">${email}</span>` : ''}
        </div>`;
      }
    },
    {
      headerName: 'Registered Image', flex: 1.2, minWidth: 130,
      cellRenderer: (p: any) => {
        const img = p.data?.registered_image;
        if (!img) return `<div style="display:flex;align-items:center;height:100%;color:#9ca3af;font-size:12px">No image</div>`;
        return `<div style="display:flex;align-items:center;height:100%;padding:4px 0">
          <img src="${img}" alt="Registered" style="height:48px;width:48px;object-fit:cover;border-radius:6px;border:1.5px solid #e5e7eb;cursor:pointer"
            onclick="window.open('${img}','_blank')" />
        </div>`;
      }
    },
    {
      headerName: 'Captured Image (Mismatch)', flex: 1.2, minWidth: 150,
      cellRenderer: (p: any) => {
        const img = p.data?.captured_image;
        if (!img) return `<div style="display:flex;align-items:center;height:100%;color:#9ca3af;font-size:12px">No image</div>`;
        const full_url = img.startsWith('http') ? img : `${'https://nova-mark-backend.undercontrol.in'}${img}`;
        return `<div style="display:flex;align-items:center;height:100%;padding:4px 0">
          <img src="${full_url}" alt="Captured" style="height:48px;width:48px;object-fit:cover;border-radius:6px;border:1.5px solid #fca5a5;cursor:pointer"
            onclick="window.open('${full_url}','_blank')" />
        </div>`;
      }
    },
    { headerName: 'Capture Type', field: 'capture_type', flex: 1, minWidth: 120 },
    {
      headerName: 'Face Score', flex: 1, minWidth: 110,
      cellRenderer: (p: any) => {
        const score = p.data?.face_score;
        if (score == null) return '-';
        const pct = (score * 100).toFixed(1);
        return `<div style="display:flex;align-items:center;height:100%">
          <span style="font-weight:600;color:#ef4444">${pct}%</span>
        </div>`;
      }
    },
    {
      headerName: 'Captured At', flex: 1.5, minWidth: 150,
      valueGetter: (p: any) => {
        if (!p.data?.captured_at) return '-';
        const d = new Date(p.data.captured_at);
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yyyy = d.getFullYear();
        const hh = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
      }
    },
  ];

  constructor(public gs: GlobalService, public ar: ActivatedRoute, public ps: ProctoringService) { }

  async ngOnInit() {
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params };
      await this.get_list(this.params);
    });
  }

  async get_list(filter?: any) {
    try {
      const res = await this.ps.get_face_logs_list(filter);
      this.items = res;
    } catch (error: any) {
      console.error('Error fetching face mismatch logs:', error);
    }
  }

  apply_filters() {
    this.get_list({ ...this.params, page: 1 });
  }
}
